import AIDataSetMutations from "./mutations.js";
import AIDataSetActions from "./action.js";
import AIDataSetGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: AIDataSetMutations,
  actions: AIDataSetActions,
  getters: AIDataSetGetters,
};
